import { jsx as _jsx } from "react/jsx-runtime";
import Svg from '../../../ui/Svg';
const ArrowLeftIcon = ({ width = 10, height = 13, ...props }) => (_jsx(Svg, { width: width, height: height, viewBox: '0 0 10 13', xmlns: 'http://www.w3.org/2000/svg', ...props, children: _jsx("path", { d: 'M9.31961 11.9419L2 6.47094L9.31961 0.999993', stroke: 'currentColor', strokeWidth: '1.3367', fill: 'none' }) }));
export default ArrowLeftIcon;
